export const Typography = ({ as: Tag = "p", className = "", children }) => (
    <Tag className={className}>{children}</Tag>
  );